export default __webpack_public_path__ + "static/media/large.a5282b76.jpg";